import {
    RouteReuseStrategy,
    ActivatedRouteSnapshot,
    DetachedRouteHandle,
  } from "@angular/router";
  
  export class CustomReusingStrategy implements RouteReuseStrategy {
    handlers: { [key: string]: DetachedRouteHandle } = {}
    future: ActivatedRouteSnapshot;
    /** Determines if this route (and its subtree) should be detached to be reused later */
    public shouldDetach(route: ActivatedRouteSnapshot): boolean {

        let reuseFor=undefined;
        if(this.future?.routeConfig?.data){
            reuseFor=( this.future?.routeConfig?.data['reuseFor']);
        }
        
        if(this.future?.firstChild?.routeConfig?.data){
            reuseFor=(this.future?.firstChild?.routeConfig?.data['reuseFor']);
        }
   
        if(reuseFor == false || typeof reuseFor == "undefined")
          setTimeout(() => this.clearHandlers(), 1000);

        return route.routeConfig.data && route.routeConfig.data['reuse'] && reuseFor;
    }

    clearHandlers()
    {
       this.handlers={};
    }

    /** Stores the detached route */
    public store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
        this.handlers[route.routeConfig.path] = handle
    }

    /** Determines if this route (and its subtree) should be reattached */
    public shouldAttach(route: ActivatedRouteSnapshot): boolean {
        return !!route.routeConfig && !!this.handlers[route.routeConfig.path]
    }

    /** Retrieves the previously stored route */
    public retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
        if (!route.routeConfig) {
            return null
        }
      
        const handler= this.handlers[route.routeConfig.path]
        return handler;
    }

    /** Determines if a route should be reused */
    public shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        this.future=future; 
        return future.routeConfig === curr.routeConfig;
    }
  }
